import { __assign } from "tslib";
import React from 'react';
import { Platform, Text, View } from "react-native";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { HtmlToNativeNative, PnmacToolTip, PnmacUIButton, PnmacText, PnmacParagraph } from "pnmac-universal-components";
import moment from "moment";
import ExpanderComponent from "./ExpanderComponent";
import { textStyle } from '../../v2/theme';
function Pending(props) {
  var pending = props.pending,
    modifications = props.modifications,
    translations = props.translations,
    loading = props.loading,
    layout = props.layout,
    setState = props.setState,
    navigation = props.navigation;
  var tableContent = [];
  if ((modifications === null || modifications === void 0 ? void 0 : modifications.isModUploadAllowed) && pending) {
    var IconDesc = /*#__PURE__*/React.createElement(CheckBoxOutlinedIcon, null);
    if (pending.statusDescription !== "Received") {
      IconDesc = /*#__PURE__*/React.createElement(CheckBoxIcon, null);
    }
    var thirdPartyCondition = [216699, 216700, 216701, 216702, 269, 270, 271, 272].includes(pending.conditionId);
    var isMisDocumentUpload = pending.conditionId == 0 && (pending.modificationConditionId == null || pending.modificationConditionId == 0);
    tableContent.push({
      view: /*#__PURE__*/React.createElement(View, {
        style: {
          marginTop: 4,
          marginRight: 10
        }
      }, IconDesc),
      flex: 1
    });
    tableContent.push({
      view: /*#__PURE__*/React.createElement(View, {
        style: {
          marginTop: 4,
          marginRight: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        loading: loading,
        idTag1: "btnUpload",
        onPress: function () {
          setState({
            conditionId: pending.conditionId
          });
        },
        disabled: thirdPartyCondition || layout.pennyWise
      }, /*#__PURE__*/React.createElement(PnmacToolTip, {
        swap: true,
        text: translations.Upload,
        title: translations.ToolTipDefault,
        style: textStyle.buttonDefaultText
      }))),
      flex: 1
    });
    tableContent.push({
      view: /*#__PURE__*/React.createElement(View, {
        id: "condtionDescription",
        style: {
          marginRight: 10
        }
      }, !pending.detailedExplanation || pending.detailedExplanation == "" ? /*#__PURE__*/React.createElement(View, null, isMisDocumentUpload ? /*#__PURE__*/React.createElement(HtmlToNativeNative, {
        value: translations.MiscDocUploadCondition,
        navigation: navigation
      }) : layout.language == "en" ? /*#__PURE__*/React.createElement(HtmlToNativeNative, {
        value: pending.conditionDescription,
        navigation: navigation
      }) : /*#__PURE__*/React.createElement(HtmlToNativeNative, {
        value: pending.spanishConditionDescription,
        navigation: navigation
      })) : /*#__PURE__*/React.createElement(Text, {
        style: textStyle.defaultTextDescription
      }, layout.language == "en" ? pending.conditionDescription : pending.spanishConditionDescription), !!pending.note && /*#__PURE__*/React.createElement(HtmlToNativeNative, {
        value: pending.note,
        navigation: navigation
      })),
      flex: 4
    });
    tableContent.push({
      view: /*#__PURE__*/React.createElement(Text, {
        id: "duedate",
        style: textStyle.defaultTextDescription
      }, pending.dueDate ? modifications.wallDate < pending.dueDate ? moment(modifications.wallDate).format("MM/DD/YYYY") : moment(pending.dueDate).format("MM/DD/YYYY") : translations.NotApplicable),
      flex: 1
    });
    tableContent.push({
      title: "Uploaded documents",
      view: /*#__PURE__*/React.createElement(ExpanderComponent, __assign({}, props, pending)),
      flex: 1
    });
  }
  return tableContent.map(function (item, index) {
    return /*#__PURE__*/React.createElement(View, {
      style: {
        flex: item.flex
      },
      key: pending.conditionId + '_' + String(index) + '_' + item.title
    }, item.view);
  });
}
function PendingTable(props) {
  var _a;
  if (!((_a = props.modifications) === null || _a === void 0 ? void 0 : _a.pendingConditions)) {
    return /*#__PURE__*/React.createElement(View, null);
  }
  var translations = props.translations;
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
    style: {
      flexDirection: 'row'
    }
  }, [{
    title: translations.MiscDocUploadHeader,
    flex: 1
  }, {
    title: translations.Upload,
    flex: 1
  }, {
    title: translations.ModDescription,
    flex: 4
  }, {
    title: translations.DueDate,
    flex: 1
  }, {
    title: "Uploaded documents",
    flex: 1
  }].map(function (item, index) {
    return /*#__PURE__*/React.createElement(View, {
      key: String(index),
      style: {
        flex: item.flex
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign({
        marginTop: 20
      }, textStyle.defaultTextTitle)
    }, item.title));
  })), props.modifications.pendingConditions.map(function (pending, pIndex) {
    return /*#__PURE__*/React.createElement(View, {
      style: {
        borderBottomWidth: 1,
        paddingBottom: 24,
        marginTop: 10,
        borderColor: "#DDDDDD",
        flexDirection: 'row'
      },
      key: pending.conditionId + '_' + pIndex
    }, /*#__PURE__*/React.createElement(Pending, __assign({}, props, {
      pending: pending
    })));
  }));
}
export default PendingTable;